/* src/app/admin/policy-group/create-or-update-policy-group.component.scss */
.sidebar {
  position: relative;
  padding: 0;
  margin: 0;
  font-family: "Noto Sans", sans-serif;
}
.sidebar .search-container {
  display: flex;
  align-items: center;
  margin: 0px;
  margin-block-start: 15px;
  margin-block-end: 30px;
  padding: 0px;
  background-color: transparent;
}
.sidebar .search-input {
  flex-grow: 1;
  height: 35px;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  border-width: 1px;
  border-radius: 10px;
  border-style: solid;
  border-color: #ebebeb;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  outline-color: #006f8a;
  font-size: 14px;
  font-family: "Noto Sans", sans-serif;
}
.sidebar .search-input::placeholder {
  color: #999;
  font-size: 14px;
}
.sidebar .search-input:focus {
  outline-offset: -2px;
  outline-width: 1px;
  outline-style: solid;
}
.sidebar .search-button {
  cursor: pointer;
  border-radius: 10px;
  padding: 2px;
  width: 39px;
  height: 39px;
  margin-inline-start: 2px;
  background-color: #006f8a;
  color: white;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.sidebar .search-button:hover {
  background-color: #00576d;
}
.sidebar .policy-list {
  margin-top: 8px;
  padding: 0px;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.sidebar .policy-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
  width: 100%;
  max-width: 400px;
}
.sidebar .policy-item label {
  color: #1d1d1d;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  margin-right: 16px;
}
.sidebar .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 24px;
}
.sidebar .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.sidebar .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.4s;
}
.sidebar .slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}
.sidebar .switch input:checked + .slider {
  background-color: #0078D4;
}
.sidebar .switch input:checked + .slider:before {
  transform: translateX(34px);
}
.sidebar .toggle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-family: "Noto Sans", sans-serif;
  font-weight: bold;
  color: white;
  pointer-events: none;
}
.sidebar .toggle-text.selected {
  color: white;
}
.search-bar .action-bar.right {
  margin-top: 30px;
}
/*# sourceMappingURL=create-or-update-policy-group.component-D46FR726.css.map */
